var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcLibraryBooks = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i7ytmtn6wa",
    d: "M3.333 5H1.667v11.667c0 .916.75 1.666 1.666 1.666H15v-1.666H3.333V5zm13.334-3.333h-10C5.75 1.667 5 2.417 5 3.333v10C5 14.25 5.75 15 6.667 15h10c.916 0 1.666-.75 1.666-1.667v-10c0-.916-.75-1.666-1.666-1.666zm-.834 7.5H7.5V7.5h8.333v1.667zM12.5 12.5h-5v-1.667h5V12.5zm3.333-6.667H7.5V4.167h8.333v1.666z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nhxtncyc9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i7ytmtn6wa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2565C7",
    mask: "url(#nhxtncyc9b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLibraryBooks, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-library-books.8bf1b6bf.svg";
export { ForwardRef as ReactComponent };